import React from 'react';
import { TableRow, TableCell } from '@mui/material';
import { Match } from "../../interfaces/Match";

// extraCell: celda opcional que se renderiza al final de la fila. La página
// Half Time no la pasa (queda undefined) y su tabla no cambia; la página
// Amistosos la usa para la columna "Melbet".
const HalfTimeRow = (
    { match, avgTimer, extraCell }: { match: Match; avgTimer: string; extraCell?: React.ReactNode }
) => {
    const under = match.bets.find(bet => /Menos de/.test(bet.name));

    return (
        <TableRow key={match.matchID}>
            <TableCell>{match.matchID}</TableCell>
            <TableCell>{match.league}</TableCell>
            <TableCell>{match.competitors.join(' vs ')}</TableCell>
            <TableCell>{match.htTimer}</TableCell>
            <TableCell>{match.sHTimer}</TableCell>
            <TableCell>{match.totGoals}</TableCell>
            <TableCell>{match.difGoals}</TableCell>
            <TableCell>{under ? `${under.name}: ${under.rate}` : 'N/A'}</TableCell>
            <TableCell>{avgTimer}</TableCell>
            <TableCell>
                <a href={match.link} target="_blank" rel="noopener noreferrer">
                    {match.link}
                </a>
            </TableCell>
            {extraCell !== undefined && <TableCell>{extraCell}</TableCell>}
        </TableRow>
    );
};

export { HalfTimeRow };
